import { Button, Col, message, Modal, Row, Typography } from 'antd';
import React, { useEffect, useState } from 'react';
import { Article } from 'types/Document';
import { DownloadOutlined } from '@ant-design/icons';
import './Article.scss';
import DocumentViewer from 'shared/DocumentViewer';
import { useContractApi } from 'api/contract';

interface ArticleViewProps {
  article: Article;
  open: boolean;
  onCancel: () => void;
}

export const ArticleView: React.FC<ArticleViewProps> = ({ article, open, onCancel }) => {
  const [documentToLoad, setDocumentToLoad] = useState<any>(undefined);

  //API
  const { getBlobFromFileURL } = useContractApi();

  useEffect(() => {
    (async () => {
      if (article && open) {
        try {
          const fileBlob: any = await getBlobFromFileURL(article?.signedUrl);
          fileBlob.name = article?.filename;
          setDocumentToLoad(fileBlob);
        } catch (err) {
          setDocumentToLoad(undefined);
          message.error(`Failed to load document ${article?.filename} `);
        }
      } else {
        setDocumentToLoad(undefined);
      }
    })();
  }, [article, open]);

  const onModalCancel = () => {
    onCancel();
  };

  return (
    <Modal
      width={1060}
      className="article-viewer"
      open={open}
      onCancel={onModalCancel}
      title={article.name}
      footer={
        <>
          <Row justify="space-between">
            <Col>
              <Typography.Link
                href={article.signedUrl}
                download={`${article.filename}.pdf`}
                className="mr-4"
                target="_blank"
              >
                <DownloadOutlined className="mr-1" /> Download file
              </Typography.Link>
            </Col>
            <Col>
              <Button onClick={onModalCancel}>Close</Button>
            </Col>
          </Row>
        </>
      }
    >
      <div key={article?.id} className={'h-screen'}>
        <DocumentViewer documentTobeLoaded={documentToLoad} />
      </div>
    </Modal>
  );
};
